/* eslint max-len: 0 */
import React, { Component } from 'react';

export default class PreviewBackgroundAudioVideoThumbnail extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="191"
        height="131"
        viewBox="0 0 191 131"
      >
        <g fill="none" fillRule="evenodd">
          <path stroke="#CDCECF" strokeWidth="3" d="M1.5 1.5h187v128H1.5z" />
          <path
            stroke="#CDCECF"
            strokeWidth="3"
            d="M62.5 97.5v8.353h108.06V97.5H62.5zM62.5 111.5v8.353h59.212V111.5H62.5zM8.5 6.757v8h34v-8h-34zM1.5 20.757V129.5h41.06V20.757H1.5z"
          />
          <path
            stroke="#CDCECF"
            strokeLinecap="square"
            strokeWidth="3"
            d="M1.5 20.5h187"
          />
          <path
            fill="#F5C8C0"
            stroke="#E84601"
            strokeWidth="3"
            d="M42.537 20.727v67H188.56v-67H42.537z"
          />
          <path
            fill="#FFF"
            stroke="#CDCECF"
            strokeWidth="3"
            d="M62.5 31.5v46.938h108.06V31.5H62.5z"
          />
          <circle
            cx="116.303"
            cy="54.303"
            r="10.303"
            fill="#CDCECF"
            opacity=".8"
          />
          <path fill="#FFF" d="M119.19 54.183L114 57.366V51z" />
        </g>
      </svg>
    );
  }
}
